export const getProcessingManagerState = state => state.processingManager
